module.exports = __webpack_public_path__ + "media/images/shared/suppliers/no-image-1d3abbb6c6e52e11f041ab8e5aaa5ed7.png";